import React from "react";
import Map from './Map'
import "./styles.css";

export default function App(props) {
	return (
		<div className="App">
			<div className="main-anreiseplaner">
				<Map {...props}/>
			</div>
		</div>
	);
}
